module.exports = __webpack_public_path__ + "media/icons/speech-bubble-circle-32ec888d.svg";